import { Brand, Site } from '@ps/web-core-enums';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import background from '../../assets/background.png';
import bigBlueBounty from '../../assets/big-blue-bounty.jpg';
import cashzuma from '../../assets/cashzuma.jpg';
import goddessyGold from '../../assets/goddessy-gold.jpg';
import pacificBoom from '../../assets/pacific-boom.jpg';
import starsSunday from '../../assets/stars-sunday.jpg';
import starsWheel from '../../assets/stars-wheel.jpg';

import {
  TXTWCL_But_donXt_panicX_WeXll_be_righ_ELL,
  TXTWCL_In_the_meanwhileX_see_our_excl_ELL,
  TXTWCL_SorryX_we_are_under_maintenanc_ELL
} from './Default.messages.json';
import styles from './Default.scss';

const games = [
  { image: starsWheel, name: 'Star Wheels', link: 'https://youtu.be/VCbUb7zxmOI' },
  { image: starsSunday, name: 'Stars Sunday Jackpot', link: 'https://youtu.be/WHPIfFcO1uQ' },
  { image: pacificBoom, name: 'Pacific Boom', link: 'https://youtu.be/ZMShGTm7brc' },
  { image: goddessyGold, name: 'Goddessy Gold', link: 'https://youtu.be/0pt1JxWZa2w' },
  { image: cashzuma, name: 'Cashzuma', link: 'https://youtu.be/dXNrnArur9k' },
  { image: bigBlueBounty, name: 'Big Blue Bounty', link: 'https://youtu.be/alS4ndPMrn8' }
];

const Default: React.FC = () => {
  const brand = useSelector(select.cms.getBrandId);
  const siteId = useSelector(select.cms.getSiteId);

  return (
    <div className={styles.container}>
      <Translation {...TXTWCL_SorryX_we_are_under_maintenanc_ELL}>
        {(message) => <h2 className={styles.title}>{message}</h2>}
      </Translation>
      <Translation {...TXTWCL_But_donXt_panicX_WeXll_be_righ_ELL}>
        {(message) => <h4 className={styles.subTitle}>{message}</h4>}
      </Translation>
      <img className={styles.background} src={background} alt="" />
      {brand === Brand.PokerStarsCasino && siteId !== Site.NET && (
        <>
          <Translation {...TXTWCL_In_the_meanwhileX_see_our_excl_ELL}>
            {(message) => <h3 className={styles.callout}>{message}</h3>}
          </Translation>
          <div className={styles.games}>
            {games.map((game) => (
              <a
                className={styles.game}
                href={game.link}
                target="_blank"
                rel="noopener noreferrer"
                key={game.name}
              >
                <img src={game.image} alt={game.name} />
              </a>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Default;
